export const DAY_PASS_NAME = 'Anytime Admission'
